import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ModalFocusService {
  focusableInputFields = [
    'input:not([disabled]):not([type="hidden"]):not([type="checkbox"]):not([type="radio"])',
    'textarea:not([disabled])',
    '[contenteditable]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  // focusableAll = [
  //   'a[href]',
  //   'button:not([disabled])',
  //   'input:not([disabled]):not([type="hidden"])',
  //   'select:not([disabled])',
  //   'textarea:not([disabled])',
  //   '[contenteditable]',
  //   '[tabindex]:not([tabindex="-1"])'
  // ].join(', ');

  focusableAll = [
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[contenteditable]',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  constructor() {}

  // focusFirstField() {
  //   let focusableElements = [
  //     'input:not([disabled]):not([type="hidden"]):not([type="checkbox"]):not([type="radio"])',
  //     'textarea:not([disabled])',
  //     '[contenteditable]',
  //     '[tabindex]:not([tabindex="-1"])'
  //   ].join(', ');

  //   let currentModal = document.querySelector('.modal-content');

  //   if (currentModal) {
  //     const modalFocusables: HTMLElement[] = Array.from(
  //       currentModal.querySelectorAll(focusableElements) as NodeListOf<HTMLElement>
  //     ).filter((el) => el.tabIndex !== -1);

  //     const autofocusable = currentModal.querySelector(`[ngbAutofocus]`) as HTMLElement;
  //     const firstFocusable = modalFocusables[0];

  //     const modalElementToFocus = autofocusable || firstFocusable || (currentModal.firstElementChild as HTMLElement);

  //     setTimeout(() => {
  //       modalElementToFocus.focus();
  //     }, 100);
  //   }
  // }

  // focusFirstField(allFields?: boolean) {
  //   let currentModal = document.querySelector('.modal-content');

  //   if (currentModal) {
  //     const modalFocusables: HTMLElement[] = Array.from(
  //       currentModal.querySelectorAll(
  //         allFields ? this.focusableAll : this.focusableInputFields
  //       ) as NodeListOf<HTMLElement>
  //     ).filter((el) => el.tabIndex !== -1);

  //     const autofocusable = currentModal.querySelector(`[myFocus]`) as HTMLElement;
  //     const firstFocusable = modalFocusables[0];

  //     const modalElementToFocus = autofocusable || firstFocusable || (currentModal.firstElementChild as HTMLElement);

  //     setTimeout(() => {
  //       modalElementToFocus.focus();
  //     }, 100);
  //   }
  // }

  focusFirstField(allFields?: boolean) {
    let currentModal = document.querySelector('.modal-content');

    if (currentModal) {
      const modalFocusables: HTMLElement[] = Array.from(
        currentModal.querySelectorAll(this.focusableAll) as NodeListOf<HTMLElement>
      ).filter((el) => el.tabIndex !== -1);

      const autofocusable = currentModal.querySelector(`[myFocus]`) as HTMLElement;
      const firstFocusable = modalFocusables[0];

      const modalElementToFocus = autofocusable || firstFocusable || (currentModal.firstElementChild as HTMLElement);

      setTimeout(() => {
        modalElementToFocus.focus();
      }, 100);
    }
  }
}
